import api from '@/api'
import storage from '@/utils/storage'

export default async function rsyncRegion () {
  // 请求参数，当 cacheAt = 0 时请求拿到所有数据，本地存在的有数据时，则请求不拿数据
  let cacheAt = 0
  if (window.yioksRegion) {
    cacheAt = window.yioksRegion.cacheAt
  } else {
    let region = storage.get('yioksRegion')
    if (region) {
      window.yioksRegion = region
      cacheAt = region.cacheAt
    }
  }

  await api({ url: '/region', method: 'GET', params: { cacheAt } }).then(res => {
    // 如果返回了数据，对数据进行处理
    if (res.regions) {
      let yioksRegion = { cacheAt: res.cacheAt }
      let map = {}
      for (let i in res.regions) {
        let region = res.regions[i]
        // 存在 c = '' name = '中国' 的数据，需要忽略
        if (region.c === '') continue
        // 对 resgion 的 key 重置
        let tmp = { code: region.c, name: region.n }
        // 省市县判断规则，省下的市，前两位 code 是以省的 code 开头，同理市下的县，前四位是以市的 code 开头
        let key = region.c.substr(0, region.c.length - 2)
        if (!map[key]) {
          map[key] = []
        }
        map[key].push(tmp)
        if (region.c.length < 6) {
          if (!map[region.c]) {
            if (region.c.length === 2) {
              tmp.city = map[region.c] = []
            }
            if (region.c.length === 4) {
              tmp.county = map[region.c] = []
            }
          } else {
            if (region.c.length === 2) {
              tmp.city = map[region.c]
            }
            if (region.c.length === 4) {
              tmp.county = map[region.c]
            }
          }
        }
      }
      yioksRegion.regions = map['']
      window.yioksRegion = yioksRegion
      storage.set('yioksRegion', yioksRegion)
    }
  })
}
